/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidArgumentException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when invalid argument provided
 */
let InvalidArgumentException = exports.InvalidArgumentException = function (_Exception) {
  _inherits(InvalidArgumentException, _Exception);

  /**
   * @param {*} argument
   * @param {String} meantType
   */
  function InvalidArgumentException(argument, meantType) {
    _classCallCheck(this, InvalidArgumentException);

    let argumentType = typeof argument;

    return _possibleConstructorReturn(this, (InvalidArgumentException.__proto__ || Object.getPrototypeOf(InvalidArgumentException)).call(this, `Invalid argument ${argument} of type ${argumentType} provided (meant ${meantType}).`, 400));
  }

  return InvalidArgumentException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/Exception/InvalidArgumentException.js
// module id = 33
// module chunks = 0